import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import Service from "../../../../services";
import SingleCheckPanel from "../../../../commonfields/SigleCheckPanel";
import { OptionsPayload } from "../../../../models/ComplianeQuestionarie";
import { catchError } from "../../../../utils/Utils";
import { options } from "yargs";
export interface CorporateStructureProps {
  changeData: (value: boolean) => void;
  corporateQuestionData: any;
  corporatestructureInitialValues: null | object;
}
export interface postQuestionData {
  answer: string;
  clientQuestionId: number;
  options: OptionsPayload[] | null;
  requireCopy:boolean | null;
  businessTypeChange?:boolean;
  clientProductId: string;
  clientId: string;
}
const CorporateStructure: React.FC<
  CorporateStructureProps &
    InjectedFormProps<Record<string, unknown>, CorporateStructureProps>
> = (props: any) => {
  const service = new Service();
  const [updateBtn, setUpdateBtn] = useState<boolean>(false);
  console.log(props.options,"options")

  const question = props?.corporateQuestionData;
  const name =
    "question_" + props?.corporateQuestionData?.questionId.toString();

  const CorporateStructureUpdate = (e: any) => {
    e.preventDefault();
    const PostQuestionData: postQuestionData = {
      answer: "",
      clientQuestionId: question.clientQuestionId,
      options: [
        {
          questionOptionId: props.formValues?.[name][0],
          answer: props.formValues?.[name][0],
        },
      ],
      requireCopy: false,
      businessTypeChange:true,
      clientProductId: props?.clientProductId,
      clientId: props?.clientId,

    };
    // change this
    service
      .postSaveWelcomeClientResponse(PostQuestionData)
      .then(() => {
        props.changeData(true);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  useEffect(() => {
    if (
      props?.formValues &&
      Object.keys(props?.formValues)?.length > 0 &&
      props?.formValues?.[name] &&
      Array.isArray(props.formValues?.[name]) &&
      props.formValues?.[name]?.length > 0
    ) {
      setUpdateBtn(false);
    } else setUpdateBtn(true);
  }, [props?.formValues]);

  const cancelUpdation = () => {
    props?.changeData(false);
  };
  return (
    <div className="corporateStructureContainer">
      <div className="cfcdesccontainer">
        <p className="corporateStructureDesc">
          What is the corporate structure of your organization? Your response
          will help us identify which documents you&apos;ll need to provide.
        </p>
        <p className="cancelcfc" onClick={cancelUpdation}>
          X
        </p>
      </div>
      <form>
        <Row>
          <Col
            md="12"
            className="d-flex flex-row justify-content-center infoImg"
          >
            <Field
              component={SingleCheckPanel}
              name={name}
              options={question?.options.sort(
                (a: any, b: any) => a.value - b.value
              )}
            />
          </Col>
          <Col>
            <div className="buttonCFCContainer">
              <p className="cancelButton" onClick={cancelUpdation}>
                Cancel
              </p>
              <button
                type="submit"
                className="updateButtonCfc"
                onClick={CorporateStructureUpdate}
                disabled={updateBtn}
              >
                Update
              </button>
            </div>
          </Col>
          <Col md="12" className="d-flex flex-row justify-content-center">
            <div className="noticecfcContainer">
              <p className="noticecfc">
                {" "}
                <FontAwesomeIcon icon={faExclamation} /> Changes to your
                business structure may change the documents you need to submit,
                including those you have already uploaded
              </p>
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
};

const mapStateToProps = (state: any, props: any) => ({
  initialValues: props.corporatestructureInitialValues, // retrieve name from redux store
  formValues: getFormValues("CorporateStructure")(state),
});

export default connect(mapStateToProps)(
  reduxForm<Record<string, unknown>, CorporateStructureProps>({
    form: "CorporateStructure",
    enableReinitialize: true,
  })(CorporateStructure)
);
